import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDishwasher = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	fill: "none",
	viewBox: "0 0 64 64",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#4A4ACF",
			d: "M29.09 1.085a4.445 4.445 0 0 1 5.82 0L37.127 3a4.45 4.45 0 0 0 3.912.97l2.848-.66a4.46 4.46 0 0 1 5.154 2.722l1.078 2.734a4.48 4.48 0 0 0 3.016 2.689l2.827.747a4.49 4.49 0 0 1 3.306 4.82l-.308 2.925a4.51 4.51 0 0 0 1.429 3.791l2.157 1.984a4.515 4.515 0 0 1 .702 5.814l-1.623 2.446a4.52 4.52 0 0 0-.486 4.025l.994 2.766a4.51 4.51 0 0 1-2.063 5.476l-2.567 1.407a4.5 4.5 0 0 0-2.289 3.336l-.397 2.914c-.3 2.2-2.15 3.85-4.356 3.884l-2.922.045a4.46 4.46 0 0 0-3.568 1.884l-1.697 2.395a4.45 4.45 0 0 1-5.65 1.401l-2.61-1.326a4.44 4.44 0 0 0-4.029 0l-2.608 1.326a4.45 4.45 0 0 1-5.65-1.401l-1.698-2.395a4.46 4.46 0 0 0-3.567-1.884l-2.923-.045a4.476 4.476 0 0 1-4.356-3.884l-.397-2.914a4.5 4.5 0 0 0-2.289-3.337L3.93 46.25a4.51 4.51 0 0 1-2.063-5.476l.994-2.766a4.52 4.52 0 0 0-.486-4.025L.752 31.537a4.515 4.515 0 0 1 .702-5.814L3.61 23.74a4.51 4.51 0 0 0 1.429-3.79l-.308-2.926a4.49 4.49 0 0 1 3.306-4.82l2.827-.747a4.48 4.48 0 0 0 3.016-2.689l1.078-2.734a4.46 4.46 0 0 1 5.154-2.721l2.848.66a4.45 4.45 0 0 0 3.912-.97z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 24,
			fill: "#99AFFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 32,
			cy: 32,
			r: 20,
			fill: "#151390"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#A2AAF0",
			fillRule: "evenodd",
			d: "M22 32a8 8 0 0 1 15.748-2H26a1 1 0 0 0-.949 1.316L26 31c-.949.316-.948.317-.948.317v.002l.002.007.008.022a14 14 0 0 0 .132.373A29 29 0 0 0 26.139 34H26a1 1 0 0 0-.948 1.317l.002.006.005.015.018.055.071.201a27 27 0 0 0 1.208 2.853c.149.299.311.605.485.905A8 8 0 0 1 22 32m8 10c-5.523 0-10-4.477-10-10s4.477-10 10-10c4.838 0 8.873 3.435 9.8 8H43a1 1 0 0 1 .949 1.316v.001l-.001.002-.002.007-.008.022a14 14 0 0 1-.132.373A29 29 0 0 1 42.861 34H43a1 1 0 0 1 .949 1.316L43 35l.949.316-.001.002-.002.005-.005.015-.018.055-.071.201c-.061.172-.15.415-.264.706-.225.58-.55 1.36-.944 2.147-.388.777-.866 1.606-1.407 2.256C40.742 41.297 39.981 42 39 42zm0-2c-.019 0-.259-.047-.7-.578-.397-.475-.794-1.146-1.155-1.87a23 23 0 0 1-.7-1.552h14.11c-.192.469-.43 1.013-.7 1.553-.36.723-.758 1.394-1.154 1.87-.443.53-.682.577-.701.577zm-4.948-4.683L26 35zM41.555 32a21 21 0 0 1-.931 2H28.376a21 21 0 0 1-.93-2z",
			clipRule: "evenodd"
		})
	]
});
const ForwardRef = forwardRef(SvgDishwasher);
export default ForwardRef;
